'use strict';

var _ = require('lodash');
var DemandTransparencyInitialForecastProfileTransformerFactory = function DemandTransparencyInitialForecastProfileTransformerFactory(DataTransformer, momentService) {
  function DemandTransparencyInitialForecastProfileTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-initial-forecast-profile';
    this.targetType = 'demand-transparency-forecast-profile-chart';
    this.priority = 1;
  }
  DemandTransparencyInitialForecastProfileTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyInitialForecastProfileTransformer.constructor = DemandTransparencyInitialForecastProfileTransformer;
  DemandTransparencyInitialForecastProfileTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyInitialForecastProfileTransformer.prototype.isCacheable = function () {
    return false;
  };
  DemandTransparencyInitialForecastProfileTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  function getProfileLevel(season, dayOfWeekGroup) {
    if (dayOfWeekGroup) {
      return season ? 'MQ_SPOS_S_DOWG' : 'MQ_SPOS_DOWG';
    } else {
      return season ? 'MQ_SPOS_S' : 'MQ_SPOS';
    }
  }
  DemandTransparencyInitialForecastProfileTransformer.prototype.transform = function (data) {
    if (data.domain === undefined) {
      return undefined;
    }
    var results = [];
    _.forEach(data.domain.hepList, function (item) {
      var curveData = [];
      var profile = item.properties.profile;
      var demands = profile.readingDayDemands;
      var length = demands && demands.length;
      for (var i = 0; i < length; i++) {
        var demand = demands[i];
        curveData.push({
          dtd: +demand.readingTimeInterval.substring(0, demand.readingTimeInterval.indexOf('d')),
          demand: +demand.blendedRemainingDemandForecast
        });
      }
      if (curveData.length > 0) {
        results.push({
          lastProcessedDateTime: momentService.of(profile.lastProcessedDateTime, momentService.FIELD.LAST_PROCESSED_DATE_TIME),
          hepKey: item.hepKey,
          classGroup: item.attributes.classSetId,
          dayOfWeekGroup: item.attributes.dayOfWeekGroup,
          season: item.attributes.season,
          profileLevel: getProfileLevel(item.attributes.season, item.attributes.dayOfWeekGroup),
          curveData: curveData
        });
      }
    });
    return results;
  };
  return DemandTransparencyInitialForecastProfileTransformer;
};
DemandTransparencyInitialForecastProfileTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandTransparencyInitialForecastProfileTransformerFactory;